export default __webpack_public_path__ + "static/media/confirm.60677618.svg";